var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { XR } from '../index';
import { Overlay } from '../component/Overlay';
import { preventClick } from '../../util/preventClick';
import clsx from 'clsx';
export function useDialog(input) {
    var header = input.header, content = input.content, footer = input.footer, className = input.className, overlayInput = input.overlayInput, size = input.size, transparent = input.transparent, toggleElement = input.toggleElement;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    function openDialog() {
        setIsOpen(true);
    }
    function closeDialog() {
        setIsOpen(false);
    }
    var Container = transparent ? 'div' : XR.Card;
    return {
        element: (React.createElement(React.Fragment, null,
            toggleElement && React.cloneElement(input.toggleElement, { onClick: openDialog }),
            isOpen && (React.createElement(Overlay, __assign({}, overlayInput, { className: clsx('XR-useDialog overlay', overlayInput === null || overlayInput === void 0 ? void 0 : overlayInput.className), onClose: closeDialog }),
                React.createElement(Container, { onClick: preventClick, className: clsx('XR-useDialog container', size, className, { transparent: transparent }) },
                    header && (React.createElement("div", { className: 'dialog-header' },
                        React.createElement(XR.SectionHeader, __assign({}, header, { close: header.close || closeDialog })))),
                    React.createElement("div", { className: 'dialog-content-container' }, content),
                    footer && React.createElement("div", { className: 'dialog-footer' }, footer)))))),
        open: openDialog,
        close: closeDialog,
        isOpen: isOpen,
    };
}
